export class PessoaListaRequest {
    public searchText: string;
    public idVendedor?: number;
    public idPessoaListaRefinamento?: number | null;
    public idUnidadeFederativa?: number;
    public idMunicipio?: number;
    public idTipoContato?: number;
}
